import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const iconsServiceApi = createApi({
  reducerPath: 'iconsServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetIcons: builder.query<any, any>({
      query: (id) => `icons/${id}`,
    }),
  }),
});

export const { useLazyGetIconsQuery } = iconsServiceApi;
